<template>
    <div 
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>

          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="">
              <v-card-title 
                class="d-flex align-center text-right popup-header fs-20 font-weight-bold">
                
                Hapus Data

                <v-spacer/>

                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->

                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 pt-4">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Customer</b> yang Anda pilih dari kode sales ini?

                <div v-if="message.error.length > 0"
                  class="text-center mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>


              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="">
                <v-spacer/>

                <v-btn
                  rounded
                  @click="updates()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, Hapus
                </v-btn>

                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <v-dialog v-model="dialog.customer"
            @keydown.esc="dialog.customer = false"
            :fullscreen="dialog.fullscreen"
            width="900"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Data Customer
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.customer = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
              
              <v-card-text 
                class="py-0 mt-4 mb-0">
                <v-text-field
                  @click:clear="search = ''; fetchCustomer();"
                  v-on:keyup.enter="fetchCustomer()"
  
                  filled
                  rounded
                  dense
                  single-line
  
                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable
  
                  v-model="search"
                  class="mb-2 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important;">
                </v-text-field>
                <v-card v-if="process.customer"
                  flat>
                  <v-card-text
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
                </v-card>
                <div class="view" v-if="!process.customer">
                  <div :class="customer.length < 1 ? '' : 'wrapper-sales-code'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: 1px solid #ededed; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Toko</th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Customer</th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Alamat Toko</th>
                      </tr>
                      <tr v-for="(item, index) in customer" :key="index">
                        <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: 1px solid #ededed; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                          <v-checkbox
                              v-model="selected.update"
                              label=""
                              hide-details
                              class="mt-0 pt-0"
                              :value="item"
                            ></v-checkbox>

                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.store_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 100%; text-align: left;">{{ item.store_province_name }}, {{ item.store_city_name }}, {{ item.store_subdistrict_name }}, {{ item.store_village_name }}</td>
                      </tr>
                    </table>
                  </div>
                  <v-card-text
                    v-if="customer.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 375px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                        <!-- <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template> -->
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>

                  <pagination v-if="!process.customer && pagination.total_data > 0"
                    @changePage="fetchCustomer($event)" 
                    @reloadPage="fetchCustomer($event)" 
                    :model="pagination" :display="paginationList"/>
                </div>
              </v-card-text>
                
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  rounded
                  width="120"
                  @click="updates()"
                  :loading="process.delete"
                  :disabled="process.delete || selected.update.length < 1"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>
  
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.customer = false; dialog.fullscreen = false;"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <section>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card v-if="process.load"
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    class="pb-0 my-4" style="height: calc(100vh - 300px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
                </v-card>
  
                <v-card v-if="!process.load && Object.keys(detail).length > 0"
                  flat
                  class="mt-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-row
                    class="pa-4 pb-2 pr-1">
                    <v-col
                      cols="12">
                      <v-card
                      to="/sales/code"
                      flat
                      color="transparent"
                      style="width: 20%;">
                      <div
                          class="d-flex align-center">
                          <v-avatar
                          tile
                          size="28"
                          style="opacity: 30%;">
                          <v-img
                              contain
                              alt="POS Amanata"  
                              :src="require('@/assets/icon/back_arrow.png')">
                              <template v-slot:placeholder>
                              <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                  </v-progress-circular>
                              </v-row>
                              </template>
                          </v-img>
                          </v-avatar>
      
                          <span
                          class="title black--text ml-3"
                          style="font-weight: 600;">
                          Detail Kode Sales
                          </span>
                      </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <table>
                      <tr>
                        <td class="font_weight_600 fs-13 py-1">
                          Nama
                        </td>
                        <td style="width: 50px;" class="text-center py-1">
                          :
                        </td>
                        <td class="font-weight-bold fs-13 py-1">
                          {{ detail.name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="font_weight_600 fs-13 py-1">
                          Deskripsi
                        </td>
                        <td style="width: 50px;" class="text-center py-1">
                          :
                        </td>
                        <td class="font-weight-bold fs-13 py-1">
                          {{ detail.desc }}
                        </td>
                      </tr>
                    </table>
                    <v-divider class="my-4"></v-divider>
                    <v-btn
                      elevation="0"
                      color="#240087"
                      @click="search = ''; message.update = 'add'; selected.update = []; dialog.customer = true; fetchCustomer();"
                      class="fs-11 white--text text-capitalize mb-1" style="border-radius: 6px;">
                      <v-icon
                        size="18">
                        mdi-plus
                      </v-icon>

                      <span
                        class="ml-2">
                        Tambah 
                      </span>
                    </v-btn>
                    <div class="view">
                      <div v-if="!process.load" :class="process.load || detail.customer.length < 1 ? '' : 'wrapper-sales-code'">
                        <table style="border-radius: 10px; width: 100%;" class="table">
                          <tr>
                            <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: 1px solid #ededed; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                            <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Toko</th>
                            <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Customer</th>
                            <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Alamat Toko</th>
                          </tr>
                          <tr v-for="(item, index) in detail.customer" :key="index">
                            <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: 1px solid #ededed; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="message.update = 'delete'; toUpdate(item.customer_id);"

                                    v-bind="attrs"
                                    v-on="on"

                                    min-width="28"
                                    small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </template>
                                
                                <span>Hapus</span>
                              </v-tooltip>
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.store_name }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.customer_name }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 100%; text-align: left;">{{ item.store_province_name }}, {{ item.store_city_name }}, {{ item.store_subdistrict_name }}, {{ item.store_village_name }}</td>
                          </tr>
                        </table>
                      </div>

                      <v-card-text
                        v-if="detail.customer.length === 0"
                        class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <v-img 
                            class="mx-auto"
                            contain
                            alt="vuetify"
                            :width="90"
                            :height="90"
                            :src="require('@/assets/image/empty.png')">
                            <!-- <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template> -->
                          </v-img>
                          <div class="mt-3 fs-16">
                            Belum Ada Data
                          </div>
                        </div>
                      </v-card-text>
                    </div>
                  </v-card-text>
                </v-card>
  
                <v-card v-if="!process.load && Object.keys(detail).length > 0"
                  flat>
                  <v-card-actions
                    class="px-4">
                    <v-spacer/>
                    
                    <v-btn
                      to="/sales/code"
                      :disabled="process.form"
                      color="red"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center ml-4"
                      style="border-radius: 10px; font-weight: 600;">
                      <v-icon 
                        size="20">
                        mdi-progress-close
                      </v-icon>
  
                      <span
                        class="ml-2">
                        Kembali
                      </span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          dialog: {
            fullscreen: false,
            snackbar: false,
  
            role: false,
            customer: false,
            delete: false,
          },
          
          detail: {},
  
          role: [],
          search: '',
  
          list: [],
          customer: [],
          pagination: {},
          paginationList: {},
          limit: 50,

          selected: {
            row: [],
            delete: [],
            update: []
          },
  
          form: {
            id: '',
            role_id: ''
          },
          
          process: {
            load: false,
            delete: false,
            role: false,
            customer: false,

          },
          message: {
            success: '',
            error: '',
            update: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
        
      },
      watch: {
        
      },
      computed: {
        company () {
          return this.$store.state.company
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      beforeMount () {
        this.fetchDetail()
      },
      mounted () {
        this.fetchCustomer()
      },
      methods: {
        async fetchDetail () {
          this.process.load = true
  
          let params = {
            id: this.$route.params.id,
            limit: 10000000000000000000
          }
  
          await get(`admin/sales_region/detail`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
  
            if (res.status === 200) {
              this.detail = res.results.data
              this.process.load = false
            }
          })
        },

        async fetchCustomer (pagination = { row: 50, page: 1 }) {
          this.process.customer = true
          this.limit = pagination.row
          this.paginationList = pagination

  
          let params = {
            // id: this.$route.params.id
            limit: pagination.row,
            page: pagination.page,
            search: this.search,
            is_blacklist: '0',
          }
  
          await get(`admin/customer/data_non_region`, { params })
          .then(response => {
            let res = response.data
  
            this.process.customer = false
  
            if (res.status === 200) {
              this.customer = res.results.data
              this.pagination = res.results.pagination
              // this.process.load = false
            }
          })
        },
        toUpdate (id) {
          this.message.error = ''
          this.selected.delete = [id]

          this.dialog.delete = this.message.update === 'delete' ? true : false
        },
        async updates () {
          this.message.error = ''

          this.process.delete = true

          let customer_arr = []
          if (this.message.update === 'add') {
            this.selected.update.forEach(item => {
              customer_arr.push(item.id)
            })
          }

          await post(`admin/customer/update_region`, {
            data: {
              id: this.message.update === 'delete' ? JSON.stringify(this.selected.delete) : JSON.stringify(customer_arr),
              sales_region_id: this.message.update === 'delete' ? '0' : this.$route.params.id
            }
          }).then(response => {
            let res = response.data

            this.process.delete = false

            if (res.status === 200) {

              this.dialog.delete = false
              this.dialog.customer = false

              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
              this.fetchCustomer()
            } else {
              this.message.error = res.message
            }
          })
        }
      }
    }
  </script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper-sales-code { 
  overflow-y: auto; 
  height: calc(100vh - 360px); 
} 

.wrapper-sales-code-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper-sales-code th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white !important;
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>